import React, { useState, useEffect } from 'react';
import UseToast from 'hooks/use-toast';
import { useQueryClient } from 'react-query';
import { getAccessToken } from 'utils/authentication';
import { isUserLoggedIn } from 'utils/authentication';

import OurPlans from 'components/pages/plans/OurPlans';
import VideoTestimonials from '@core/components/videotestimonials/VideoTestimonials';
import OurPlansPro from './OurPlansPro';
import WhatYouWillGet from 'components/pages/plans/WhatYouWillGet';
import CompareSection from 'components/pages/plans/CompareSection';
import CompareSectionPro from './CompareSectionPro';
import SelectYourPlanSection from 'components/pages/plans/SelectYourPlanSection';
import FAQSection from 'components/pages/plans/FAQSection';
import PromotionBanner from '@core/components/promotionbanner/PromotionBanner';
import ProofNumbers from './ProofNumbers';
import CertifiedTrust from './CertifiedTrust';
import B2BOffer from './B2BOffer';
import PlansTestimonials from './PlansTestimonials';
import ZamannProduct from './ZamannProduct';
import Newsletter from '@core/components/contentparser/sections/Newsletter/Newsletter';



const PlansWrapper = ({ data }) => {
    const { ToastContainer, toast } = UseToast();
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const [haspromotion, setHasPromotion] = useState(false);
    const [period, setPeriod] = useState('Annual');
    const queryClient = useQueryClient();
    useEffect(() => {
        setIsAuthenticated(isUserLoggedIn());
        data.promotion != null ? setHasPromotion(true) : setHasPromotion(false);
        queryClient.invalidateQueries(['user-metadata', getAccessToken()]);
    }, []);



    return (
        <section className='w-100'>
            <ToastContainer />
            {/* {haspromotion &&
                <PromotionBanner data={data.promotion} />
            } */}
            {data?.pro_monthly ?
                <OurPlansPro data={data} isLoggedIn={isAuthenticated} toast={toast} period={period} setPeriod={setPeriod} />
                :
                <OurPlans data={data} isLoggedIn={isAuthenticated} toast={toast} />
            }
            <B2BOffer />
            <CertifiedTrust />
            {/* <ProofNumbers /> */}
            {data?.pro_monthly ?
                <CompareSectionPro data={data} isLoggedIn={isAuthenticated} toast={toast} period={period} setPeriod={setPeriod} />
                :
                <CompareSection data={data} isLoggedIn={isAuthenticated} toast={toast} />
            }
            <WhatYouWillGet />
            <VideoTestimonials />
            
            
            {/* <SelectYourPlanSection data={data} isLoggedIn={isAuthenticated} toast={toast} /> */}
            <PlansTestimonials data={data.testimonials} />
            <FAQSection />
            <Newsletter />
            <ZamannProduct />

        </section>
    );
};


export default PlansWrapper;